
import { EditableDropDownComponentBase } from './editable-dropdown.base.component';

import { IIdName } from '../../_entities';

export abstract class EditableIdNameDropdown extends EditableDropDownComponentBase<number> {
    constructor() {
        super();
    }
    //_itemsUrl: string;
    dropdownItems: IIdName[];

    protected abstract getIdNameTuples(): Promise<IIdName[]>;

    protected getItems(): Promise<number[]> {

        return this.getIdNameTuples().then(result => {
            this.dropdownItems = result;
            return this.dropdownItems.map(r => r.id);
        });

    }
    protected mapItem(items: number[], item: number): number {
        return items.find(x => x === item);
    }

    protected getDisplayValue(itemToFind: number) {

        if (this.dropdownItems) {
            const item = this.dropdownItems.find(x => x.id === itemToFind);
            if (item) {
                return item.name;
            }
        }

        return itemToFind.toString();
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/editable-id-name-dropdown.component.ts